import { initialState } from './../state';
import { FetchCurrentProject } from './FetchProject';
import { ProjectDetailState } from '../state';
import { DelegateMapEntry } from 'containers/Base/ActionDelegate';
import { Action } from 'redux';
import { ThunkAction } from 'redux-thunk';
import { RootState } from 'store/reducer';

const SELECT_PROJECT = 'project/select';

export interface SelectProjectAction {
  type: typeof SELECT_PROJECT;
  projectId: string;
}

export const selectProject = (
  projectId: string
): ThunkAction<void, RootState, unknown, Action<string>> => async dispatch => {
  dispatch({
    type: SELECT_PROJECT,
    projectId,
  } as SelectProjectAction);
  dispatch(FetchCurrentProject());
};

export const selectProjectDelegate: DelegateMapEntry<
  SelectProjectAction,
  ProjectDetailState
> = {
  [SELECT_PROJECT]: (
    state: ProjectDetailState,
    action: SelectProjectAction
  ): ProjectDetailState => {
    return {
      ...initialState,
      selectedProjectId: action.projectId,
    };
  },
};
